import { useState, useMemo, useEffect, useRef } from 'react';

export default function usePaginacao(itens, porPaginaPadrao = 10) {
  const [pagina, setPaginaRaw] = useState(1);
  const [porPagina, setPorPaginaRaw] = useState(porPaginaPadrao);
  const prevLen = useRef(itens.length);

  useEffect(() => {
    if (itens.length !== prevLen.current) {
      setPaginaRaw(1);
      prevLen.current = itens.length;
    }
  }, [itens.length]);

  const totalPaginas = Math.max(1, Math.ceil(itens.length / porPagina));

  const setPagina = (p) => setPaginaRaw(Math.min(Math.max(1, p), totalPaginas));

  const setPorPagina = (n) => {
    setPorPaginaRaw(n);
    setPaginaRaw(1);
  };

  const paginaValida = Math.min(pagina, totalPaginas);

  const paginados = useMemo(() => {
    const inicio = (paginaValida - 1) * porPagina;
    return itens.slice(inicio, inicio + porPagina);
  }, [itens, paginaValida, porPagina]);

  const inicio = itens.length === 0 ? 0 : (paginaValida - 1) * porPagina + 1;
  const fim = Math.min(paginaValida * porPagina, itens.length);

  return { paginados, pagina, setPagina, porPagina, setPorPagina, totalPaginas, inicio, fim, total: itens.length };
}
